import { pluginApi } from 'services/api';

export default async (campaignId: number) => {
  await pluginApi.delete(`/fmc-campaigns/delete/${campaignId}`);
};
